import { Card, Col, Row } from 'antd'
import React, { useState } from 'react'
import Button from '../../../../../components/FormElements/Button'
import './style.css'
import carPlaceholder from '../../../../../assets/images/car.png'
import useMyGarageApi from '../../../../../config/hooks/api/mygarage/useMyGarageApi'
import deleteIcon from '../../../../../assets/images/deleteIcon.png'
import { setAppLoading, setMessage } from '../../../../../store/common/generalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Modal from '../../../../../components/Modal'
import Prompt from '../../../../../components/Prompt'

const vehicleDeletePromptMsg = 'Are you sure you want to remove this vehicle?'

const Car = ({ data, refreshFeedHandler }) => {

    
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { deleteVehicle } = useMyGarageApi()
    const { loggedInUser } = useSelector(state => state?.auth)

    const [vehicleToDelete, setVehicleToDelete] = useState('')
    const [prompt, setPrompt] = useState(false)

    const handleVehicleDeletePrompt = (vehicleRegistrationNo) => {
        if (vehicleRegistrationNo) {
            setVehicleToDelete(vehicleRegistrationNo)
            setPrompt(true)
        }
    }

    const handlePromptResponse = async (resp) => {
        try {
            if (resp) {
                dispatch(setAppLoading(true))

                const response = await deleteCarHandler(vehicleToDelete)
                if (response) {
                    setPrompt(false)
                    dispatch(setAppLoading(false))
                }
            }
            else {
                setPrompt(false)
                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const deleteCarHandler = async (vehicleRegistrationNumber) => {
        try {
            let resp = await deleteVehicle(vehicleRegistrationNumber);
            if (resp?.status == 200) {
                dispatch(setMessage(resp?.data?.message))
                refreshFeedHandler()
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <React.Fragment>
            {data && (
                <Card bordered={false} className="card-main">
                    <Card bordered={false} className='bg-gray-100 card-gray'>
                        <Card bordered={false} className='mb-3'>
                            <div className='flex justify-end mb-1'>
                                <img
                                    src={deleteIcon}
                                    className='w-6 h-6 cursor-pointer'
                                    onClick={() => handleVehicleDeletePrompt(data?.vehicleRegistrationNumber)}
                                    alt='delete icon'
                                />
                            </div>
                            <img src={carPlaceholder} alt='car' className='img-fluid' />
                            <hr className='border-dashed border-1 border-gray-200 mb-4' />
                            <div className='model flex flex-col'>
                                <h4 className='heading-4 font-bold mb-1 registration'>{data?.vehicleRegistrationNumber}</h4>
                                <h6 className='heading-6 font-bold text-sm'>{data?.make} {data?.model}</h6>
                            </div>
                            <hr className='border-dashed border-1 border-gray-200 mb-4' />
                            <Row>
                                <Col md={8} sm={8} xs={24}>
                                    <div
                                        className='text-center md:border-r sm:border-r border-r-0 md:border-b-0 sm:border-b-0 border-b 
                                        px-1'
                                    >
                                        <h6 className='heading-6 font-bold mb-0'>{data?.year}</h6>
                                        <small className='text-xs text-slate-500 inline-block font-medium md:mb-0 sm:mb-0 mb-2'>Year</small>
                                    </div>
                                </Col>
                                <Col md={8} sm={8} xs={24}>
                                    <div
                                        className='text-center md:border-r sm:border-r border-r-0 md:border-b-0 sm:border-b-0 border-b 
                                        px-1 md:my-0 sm:my-0 my-2'
                                    >
                                        <h6 className='heading-6 font-bold mb-0'>{data?.engineSize}</h6>
                                        <small className='text-xs text-slate-500 inline-block font-medium md:mb-0 sm:mb-0 mb-2'>Engine Size</small>
                                    </div>
                                </Col>
                                <Col md={8} sm={8} xs={24}>
                                    <div className='text-center px-1'>
                                        <h6 className='heading-6 font-bold mb-0'>{data?.fuelType}</h6>
                                        <small className='text-xs text-slate-500 font-medium'>Fuel Type</small>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                        {
                            loggedInUser?.type !== "Service Provider" &&
                            <div>
                                <Button.Basic
                                    onClick={() => navigate('/quote-form', { state: { carRegNo: data?.vehicleRegistrationNumber } })}
                                    disabled={false}
                                    icon={null}
                                    loading={false}
                                    type="primary"
                                    size='medium'
                                    text='Get Quotes'
                                    className='btn-primary w-full'
                                />
                            </div>
                        }
                    </Card>
                </Card>
            )}

            <Modal.Basic
                open={prompt}
                closeable={false}
                width={300}
                maskClosable={false}
            >
                <Prompt.Basic
                    message={vehicleDeletePromptMsg}
                    onChange={handlePromptResponse}
                    closeModal={() => setPrompt(false)}
                />
            </Modal.Basic>
        </React.Fragment>
    )
}

export default Car